import { NamedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";
import { LookupDataProvidersQueryKey } from "./LookupDataProvidersQueryKey";

export type Standard = NamedProperty;

export const useStandards = (): SprintQueryResult<Standard[]> => {
    const { getStandards } = useMasterLookupsApi();

    return useSprintQuery<Standard[]>({
        queryKey: [LookupDataProvidersQueryKey.Standards],
        queryFn: async (): Promise<Standard[]> => {
            const response = await getStandards();
            return response.items;
        }
    });
};
